import React from 'react'

export default function GroupComapnies01() {
  return (
    <div className='p-3 bg-cream'>
     <p className='fit'>There are no group companies to show.</p>
    </div>
  )
}
